export default "__VITE_ASSET__cY_N65Un__"